/**
 * Provides a way to compare two objects
 * and get changed data
 * which can then be sent to back-end side.
 *
 * @param {T} initialValues
 * @param {T} valuesToCompare
 * @returns {Partial<T>}
 */
export function getChangedData<T extends Record<string, any>>(
  initialValues: T,
  valuesToCompare: T,
): Partial<Record<string, any>> {
  const record: Record<string, any> = {};

  Object.keys(valuesToCompare).forEach((key: string) => {
    const isEqual = valuesToCompare[key] === initialValues[key];
    const isObject = typeof valuesToCompare[key] === 'object';

    // Checks that isn't an object and isn't equal
    if (!isObject && !isEqual) {
      record[key] = valuesToCompare[key];
    }
    // If is an object, and the object isn't equal
    if (isObject && !isEqual) {
      record[key] = getChangedData(
        initialValues[key],
        valuesToCompare[key],
      );
    }
  });

  return record;
}

export function getEnumKeyByEnumValue<T>(
  enumType: T,
  enumValue: T[keyof T],
): keyof T {
  for (const key in enumType) {
    if (enumType[key] === enumValue) {
      return key;
    }
  }

  throw new Error('Could not get enum key by enum value');
}
